// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"sy_a bhn_b bhn_bj","SubscribedPhotoblogs__link":"sy_b bhn_a bhn_r"};